export default {"src":"/_next/static/media/techcabal.0bb0439e.svg","height":29,"width":133,"blurWidth":0,"blurHeight":0};